import { Monoid, Semigroup } from '@effect/typeclass';
export const possibleHandednessString = (ph) => `[${Array.from(ph.values()).join(', ')}]`;
const unitPossibleHandedness = () => new Set(['left', 'right', 'none']);
export const possibleHandednessFromConfigSpace = (configSpace) => (setConditionIds) => {
    const { conditions } = configSpace;
    const conditionOrientations = setConditionIds.map(id => {
        const condition = conditions.find(c => c.id === id);
        if (condition)
            return condition.orientation;
        return 'none';
    });
    return new Set(conditionOrientations).add('none');
};
export const possibleHandednessFromApiAttachment = (attachment) => attachment.conditions.length === 0
    ? unitPossibleHandedness()
    : // all things have a 'none' possible handedness in our current behaviour, no
        // matter what - we don't have furniture which only displays in corners so none
        // always needs to be handled, even if just by showing one of the left or right
        // handednesses.
        new Set(attachment.conditions.map(condition => condition.orientation)).add('none');
function intersection(setA, setB) {
    const _intersection = new Set();
    for (const elem of setB) {
        if (setA.has(elem)) {
            _intersection.add(elem);
        }
    }
    return _intersection;
}
export const everyPossibleHandedness = unitPossibleHandedness;
export function difference(setA, setB) {
    const _difference = new Set(setA);
    for (const elem of setB) {
        _difference.delete(elem);
    }
    return _difference;
}
export const intersectionSemigroup = Semigroup.make((a, b) => intersection(a, b));
export const intersectionMonoid = Monoid.fromSemigroup(intersectionSemigroup, unitPossibleHandedness());
export const possibleHandednessFromApiAttachments = (attachments) => intersectionMonoid.combineAll(attachments.map(possibleHandednessFromApiAttachment));
export const possibleHandednessFromHandedness = (handedness) => new Set([handedness]);
